<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="设备编号">
            <a-input v-model="searchP.deviceno" style="width:400px;" placeholder="设备编号"></a-input>
        </a-form-item>
        <a-form-item label="商户编码">
            <a-input v-model="searchP.shopcode" placeholder="商户编码"></a-input>
         </a-form-item>
         <a-form-item label="客户端编码">
             <a-input v-model="searchP.appcode" placeholder="客户端编码"></a-input>
          </a-form-item>
        <a-form-item label="门店编码">
            <a-input v-model="searchP.branchcode" placeholder="门店编码"></a-input>
         </a-form-item>
         <a-form-item label="用户id">
            <a-input v-model="searchP.userid" placeholder="用户id"></a-input>
         </a-form-item>

         <a-form-model-item ref="platformname" label="平台" prop="platformname">
            <platformSelecter :showAll="false" v-model="searchP.platformtype"></platformSelecter>
        </a-form-model-item>

        <a-form-item label="创建时间">
            <a-range-picker
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import platformSelecter from '../../components/platformSelecter'

export default {
    components:{
        platformSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            timeRange:undefined,
            dateFormat:"YYYY-MM-DD HH:mm",
            searchP:{
                deviceno:'',
                shopcode:'',
                branchcode:'',
                starttime:'',
                endtime:'',
                isonline:'',
                platformtype:'',
                userid:'',


            },
        }
    },

    methods:{
        onChange(v,t){
            this.searchP.starttime = t[0];
            this.searchP.endtime = t[1]
            console.log(this.timeRange)
        },
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
        handleChange(item){
            this.searchP.passwaytype = item.passwaytype;
        },
    },
    mounted(){
        let query = this.$route.query;
        this.searchP.deviceno = query.deviceno ? query.deviceno : '';
        this.handleSubmit()
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

